import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ConfigProvider } from "@/contexts/ConfigContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import TopNav from "@/components/TopNav";
import ScrollToTop from "@/components/ScrollToTop";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Explore from "@/pages/Explore";
import NotFound from "@/pages/NotFound";
import AuthorSite from "@/pages/AuthorSite";
import AboutPage from "@/pages/AboutPage";
import ArticleDetail from "@/pages/ArticleDetail";
import Articles from "@/pages/Articles";
import Authors from "@/pages/Authors";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import AboutUs from "@/pages/AboutUs";
import SeriesSingle from "@/pages/SeriesSingle";
import SeriesList from "@/pages/SeriesList";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import ArticlesList from "@/pages/dashboard/ArticlesList";
import ArticleEditor from "@/pages/dashboard/ArticleEditor";
import Profile from "@/pages/dashboard/Profile";
import ThemeSettings from "@/pages/dashboard/ThemeSettings";
import Analytics from "@/pages/dashboard/Analytics";
import CustomDomain from "@/pages/dashboard/CustomDomain";
import Subscribers from "@/pages/dashboard/Subscribers";
import Library from "@/pages/dashboard/Library";
import SeriesManager from "@/pages/dashboard/SeriesManager";

export default function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
      <ConfigProvider>
        <ThemeProvider>
          <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <GoogleAnalytics />
            <div className="App min-h-screen flex flex-col">
              <TopNav />
              <div className="flex-1">
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/explore" element={<Explore />} />
                  <Route path="/series" element={<SeriesList />} />
                  <Route path="/articles" element={<Articles />} />
                  <Route path="/authors" element={<Authors />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/about" element={<AboutUs />} />

                  <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>

                    <Route index element={<ArticlesList />} />
                    <Route path="new" element={<ArticleEditor />} />
                    <Route path="edit/:id" element={<ArticleEditor />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="theme" element={<ThemeSettings />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="domain" element={<CustomDomain />} />
                    <Route path="subscribers" element={<Subscribers />} />
                    <Route path="library" element={<Library />} />
                    <Route path="series" element={<SeriesManager />} />
                  </Route>


                  <Route path="/:username" element={<AuthorSite />} />
                  <Route path="/:username/about" element={<AboutPage />} />
                  <Route path="/:username/series/:slug" element={<SeriesSingle />} />
                  <Route path="/:username/:slug" element={<ArticleDetail />} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </div>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
      </ConfigProvider>
    </GoogleOAuthProvider>
  );
}
